import React from 'react';
import {properties} from "../../config/properties"; // 👈 Importa qui la tua immagine

const Spinner = ({ active }) => {
    // Mostra lo spinner solo se la prop 'active' è true
    if (!active) {
        return null;
    }

    return (
        <div className="spinner-container">
            <div className="spinner">
                <img src={properties.baseAppUrl + properties.baseImages + '/ic-logo.svg'} alt="Caricamento in corso..." />
            </div>
        </div>
    );
};

export default Spinner;